import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { optionIssues, requireOptions } from './_checks.js';
import { draftFields, Option } from './_shared.js';
import { asList } from './types.js';

/**
 * A dialogue choice: the player picks a reply, and the reply decides where the story
 * goes. Every option must name an outcome — there is no grading here, so routing is
 * the only thing an option does.
 */
export const dialogue: ActivityDefinition = {
  type: 'dialogue',
  summary: 'A dialogue choice — the player picks a reply, and the reply routes the story.',
  setup: z.looseObject({
    ...draftFields,
    options: z.array(Option).optional(),
  }),
  check: (setup, ctx) => {
    const options = asList(setup.options);
    return [
      ...requireOptions('dialogue', options, ctx),
      ...optionIssues('dialogue', options, ctx, { requireOutcomes: true }),
    ];
  },
};
